<template>
  <form v-if="value" @submit.prevent="onSubmit">

    <form-sticky-header :title="title">
      <slot name="actions"></slot>
    </form-sticky-header>

    <form-fieldset title="Général" id="form-general">
      <template slot="description">
        <p class="text-muted">
          Les métiers permettent de regrouper les <router-link :to="{name: 'collections'}">collections</router-link> dans l'interface.<br />
          <br />
          N'oubliez pas de <strong>publier votre métier</strong> si celui-ci n'apparaît pas dans la liste.
        </p>
        <hr />
        <form-group>
          <form-switch v-model="model.published">Publier ce métier</form-switch>
        </form-group>
      </template>

      <row>
        <column sm="6">
          <form-group label="Nom du métier" required>
            <form-input type="text" v-model="model.name" required/>
          </form-group>
        </column>
        <column sm="6">
          <form-group label="Alias du métier">
            <form-input type="text" pattern="[A-Za-z0-9\-_]+" title="Seulement caractères autorisés dans les URLs" v-model="model.slug" placeholder="(généré automatiquement)" />
            <span slot="help">Est utilisé dans les URL (automatiquement généré si laissé vide).</span>
          </form-group>
        </column>
      </row>
      <row>
        <column sm="6">
          <form-group label="Ordre d'affichage">
            <form-order v-model.numeric="model.order" />
          </form-group>
        </column>
      </row>
      <row>
        <column sm="6">
          <form-group label="Icône">
            <form-file-upload v-model="model.icon" image />
            <span slot="help">Choisissez un fichier PNG de préférence de 512&times;512 px afin d'avoir une qualité de rendu optimale.</span>
          </form-group>
        </column>
        <column sm="6">
          <form-group label="Image de couverture">
            <form-file-upload v-model="model.background" image />
            <span slot="help">Choisissez un fichier JPEG de préférence de 2048&times;1440 px afin d'avoir une qualité de rendu optimale.</span>
          </form-group>
        </column>
      </row>
    </form-fieldset>

  </form>
</template>

<script>
  import _omit from 'lodash/omit';

  export default {
    components: {
      FormStickyHeader: () => import('../../components/FormStickyHeader.vue'),
      FormFileUpload: () => import('../../components/FormFileUpload.vue'),
      FormOrder: () => import('../../components/FormOrder.vue'),
      FormSwitch: () => import('package-common-vuejs/src/components/form/FormSwitch'),
    },
    props: {
      title: String,
      value: Object,
    },
    data() {
      return {
        model: {},
      };
    },
    computed: {
    },
    created() {
      this.updateModel(this.value);
    },
    watch: {
      value() {
        this.updateModel(this.value);
      }
    },
    methods: {
      updateModel(value) {
        this.model = {
          ...value,
          icon: (value && value.icon) ? value.icon.id : null,
          background: (value && value.background) ? value.background.id : null,
        };
      },
      onSubmit() {
        this.$emit('submit', _omit({
          ...this.model,
        }, ['id', '__typename']));
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/categories/CategoryForm.vue